import React from 'react';
import _ from 'lodash';

import { useItemFulfillmentWidgetQuery } from 'generated/graphql';



export interface ILineItem {
  id: string;
  sku: string;
  quantity: number;
  assignments: string[];
}

export interface ISkuSwap {
  id: string;
  purchasedSku: string;
  swappedSku: string;
  quantity: number;
}

export interface IData {
  lineItems: ILineItem[];
  skuSwaps: ISkuSwap[];
}

export function useQuery(orderId: string) {
  const tuple = useItemFulfillmentWidgetQuery({
    variables: {
      orderId
    }
  });

  return React.useMemo(
    () => {
      const lineItems = _.flatMap(
        tuple.data?.order?.itemFulfillment?.lineItems ?? [],
        (lineItem): ILineItem => ({
          id: lineItem.id,
          sku: lineItem.item.sku,
          quantity: lineItem.quantity,
          assignments: lineItem.assignments.map(ass => ass.inventoryNumber)
        }));

      const skuSwaps = _.flatten(_.map(tuple.data?.order?.lineItems, lineItem => _.map(lineItem.swaps, (swap): ISkuSwap => ({
        id: swap.id,
        purchasedSku: lineItem.product.sku,
        swappedSku: swap.product.sku,
        quantity: swap.quantity
      }))));
      const data: IData = {
        lineItems,
        skuSwaps
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
